<div class="audit-mixin-indicator">
  <!--  <span class="material-symbols-outlined" (click)="openModal($event)">arrow_right</span>-->
  <div class="audit-arrow" (click)="openModal($event)"></div>
</div>
